export default __webpack_public_path__ + "static/evitat-logo-green-share-f957037eec80e5ac7be0a3cb582a61af.jpg";